
import {Navbar,Footer} from '../components';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import { useNavigate } from "react-router-dom";


function Misentry() {
  const { id } = useParams();
  const navigate=useNavigate();

    if(localStorage.getItem('branchID')===null){
        window.location.replace('/');
    }

  const [inputData,setInputData]=useState([]);

  useEffect(() => {
    const getInputData = async () => {
        const response=await axios.get(configData.SERVER_URL+`/misentry/${id}`)
        setInputData(response.data[0]);
    };
    getInputData();

  }, []);

  const handleInput=(e)=>{
    const {name,value}=e.target; 
    const val = Number(value) || 0;
    // setInputData({...inputData,[name]:value}); 
     
    const newData = {...inputData,[name]: value}; 
    newData.salesValue=Number(newData.salesQtyValue) + Number(newData.othersSalesValue);

    newData.operatingInc=Number(newData.salesValue)-Number(newData.cogs);
    newData.operatingPL=Number(newData.operatingInc) - Number(newData.operatingExpense);
    newData.nonoperatingPL=Number(newData.nonoperatingInc) - Number(newData.nonoperatingExpense);   
    newData.profitLoss = Number(newData.operatingPL) + Number(newData.nonoperatingPL);

    setInputData(newData);

  }

  const handleInputPro=(e)=>{
    const {name,value}=e.target; 
    const val = Number(value) || 0;
     
    const newData = {...inputData,[name]: value}; 

    newData.proQtyValue=Number(newData.rmCost) + Number(newData.overhead);
    newData.proValue=Number(newData.proQtyValue) + Number(newData.othersProValue);

    setInputData(newData);

  }


  const handleInputPL=(e)=>{
    const {name,value}=e.target; 
    const val = Number(value) || 0;
     
    const newData = {...inputData,[name]: value}; 

    newData.operatingPL=Number(newData.operatingInc) - Number(newData.operatingExpense);
    newData.nonoperatingPL=Number(newData.nonoperatingInc) - Number(newData.nonoperatingExpense);   
    newData.profitLoss = Number(newData.operatingPL) + Number(newData.nonoperatingPL);

    setInputData(newData);

  }


  const handleSubmit=async(e)=>{
    e.preventDefault();

    let res=await axios.post(configData.SERVER_URL+'/misDataPost',inputData);
    if(res.status===200){
      if(res.data===1){
        alert('Successfully Updated');
        navigate('/home/mis');
      }
    } else{
      alert('System Error');
    } 
  }

  return (
    <>
      <div className='container'>

      <form onSubmit={handleSubmit}>
      {/* { misData && misData.length>0 && misData.map((data)=>    */}
          <div className="card my-3">
              <div className="card-header"><h3>MIS Entry</h3><span className="float-right small blink">(Amount In Lac)</span></div>
              <div className="card-body"> 
                  <div className="row ">                             
                      <div className="col-lg-2">Month
                          <input type="text" className="form-control" id="month" name="month" disabled value={inputData.monthName}></input>
                      </div>
                      
                      <div className="col-lg-2">Unit
                          <input type="text" className="form-control" id="unit" name="unit" value={inputData.units}  disabled></input>
                      </div>

                      <hr className="my-3"/>
                      <div className="col-lg-2">Pro.Qty
                          <input type="number" className="form-control" id="proQty" name="proQty" value={inputData.proQty} onChange={(e)=>{handleInputPro(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Raw Material Cost
                          <input type="number" className="form-control" id="rmCost" name="rmCost" value={inputData.rmCost} onChange={(e)=>{handleInputPro(e)}} required="required" ></input>
                      </div>
                      <div className="col-lg-2">Overhead Cost
                          <input type="number" className="form-control" id="overhead" name="overhead" value={inputData.overhead} onChange={(e)=>{handleInputPro(e)}} required="required" ></input>
                      </div>

                      <div className="col-lg-2">Pro.Value
                          <input type="number" className="form-control" id="proQtyValue" name="proQtyValue" value={inputData.proQtyValue}  disabled ></input>
                      </div>
                      <div className="col-lg-2">Other Pro.Value
                          <input type="number" className="form-control" id="othersProValue" name="othersProValue"  value={inputData.othersProValue} onChange={(e)=>{handleInputPro(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Total Pro.Value
                          <input type="number" className="form-control" id="proValue" name="proValue" value={inputData.proValue}  disabled ></input>
                      </div>

                      <hr className="my-3"/>
                      <div className="col-lg-2">Sales.Qty
                          <input type="number" className="form-control" id="salesQty" name="salesQty" value={inputData.salesQty} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Net Sales.Value
                          <input type="number" className="form-control" id="salesQtyValue" name="salesQtyValue" value={inputData.salesQtyValue} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Other Sales.Value
                          <input type="number" className="form-control" id="othersSalesValue" name="othersSalesValue" value={inputData.othersSalesValue} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Total Sales.Value
                          <input type="number" className="form-control" id="salesValue" name="salesValue" value={inputData.salesValue} disabled></input>
                      </div>

                      {/* <hr className="my-3"/>
                      <div className="col-lg-2">Work In Process(Qty)
                          <input type="number" className="form-control" id="workInProcess" name="workInProcess" value={inputData.workInProcess} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>    
                      <div className="col-lg-2">Finish Goods Qty
                          <input type="number" className="form-control" id="goodsQty" name="goodsQty" value={inputData.goodsQty} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Finish Goods Value
                          <input type="number" className="form-control" id="goodsValue" name="goodsValue" value={inputData.goodsValue} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div> */}

                      <hr className="my-3"/>
                      <div className="col-lg-2">COGS
                          <input type="number" className="form-control" id="cogs" name="cogs" value={inputData.cogs} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Gross (P/L)
                          <input type="number" className="form-control" id="operatingInc" name="operatingInc" value={inputData.operatingInc} disabled defaultValue={0}></input>
                      </div>
                      <div className="col-lg-2">Operating Exp.
                          <input type="number" className="form-control" id="operatingExpense" name="operatingExpense" value={inputData.operatingExpense} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Operating (P/L)
                          <input type="number" className="form-control" id="operatingPL" name="operatingPL" value={inputData.operatingPL}  disabled defaultValue={0} ></input>
                      </div>

                      <hr className="my-3"/>
                      <div className="col-lg-2">Non-Operating Income
                          <input type="number" className="form-control" id="nonoperatingInc" name="nonoperatingInc" value={inputData.nonoperatingInc} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Non-Operating Exp.
                          <input type="number" className="form-control" id="nonoperatingExpense" name="nonoperatingExpense" value={inputData.nonoperatingExpense} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>
                      <div className="col-lg-2">Non-Operating (P/L)
                          <input type="number" className="form-control" id="nonoperatingPL" name="nonoperatingPL" value={inputData.nonoperatingPL}  disabled defaultValue={0}></input>
                      </div>

                      <hr className="my-3"/>
                      
                      <div className="col-lg-2">Profit/Loss
                          <input type="number" className="form-control" id="profitLoss" name="profitLoss" value={inputData.profitLoss} disabled ></input>
                      </div>
                      <div className="col-lg-2">Con. National Exch. 
                          <input type="number" className="form-control" id="nationalExc" name="nationalExc" value={inputData.nationalExc} onChange={(e)=>{handleInput(e)}} required="required"></input>
                      </div>

                      <div className="text-center">
                          <button class="my-2  btn btn-lg btn-info" type="submit">Save</button>
                      </div>
                      
                  </div>
              </div>
              <div className="card-footer text-muted">Footer</div>
          </div>
          {/* )} */}
      </form>

    </div>
    </>
  );
}

export default Misentry